export const doctors = [
  {
    id: 1,
    name: "Dr. Jimmy Goyal",
    qualifications:
      "BAMS, MBA (Hospital Management), MD (Roga Nidana) – Scholar",
    specializations: [
      "Joint Disorders",
      "Dermatology",
      "Gastroenterology",
      "Mental Health",
      "Male Infertility",
      "Lifestyle Disorders",
    ],
    expertise: [
      "Joint disorders and spinal conditions",
      "Dermatological diseases",
      "Gastrointestinal disorders (IBS, GERD, hyperacidity)",
      "Mental health conditions (insomnia, anxiety, stress-related disorders)",
      "Male infertility (low sperm count, poor motility, reproductive health)",
      "Lifestyle disorders (obesity, diabetes, dyslipidemia, hypertension, metabolic syndrome)",
      "Integration of classical Ayurvedic principles with modern medical concepts",
      "Evidence-based, holistic, patient-centric approach",
      "Strong clinical observation and diagnostic skills",
    ],
    photo_url:
      "https://customer-assets.emergentagent.com/job_ayur-wellness-17/artifacts/bkyaup6t_dr.%20jimmy.jpeg",
    available: true,
    whatsapp_number: "918295080493",
    location: "Tricity",
    bio: "Dr. Jimmy Goyal brings a unique blend of traditional Ayurvedic wisdom and modern medical understanding to his practice. With extensive experience in treating lifestyle disorders and chronic conditions, he focuses on root-cause treatment and holistic healing.",
  },
  {
    id: 2,
    name: "Dr. Aman Arora",
    qualifications: "BAMS",
    specializations: [
      "Musculoskeletal Disorders ",
      "Spinal Disorders ",
      "Neurodegenerative Disorders",
      "Cupping Therapy for pain management and detoxification",
      "Liver & Renal Diseases",
      "Hairfall and Premature graying",
      "Joint Pain",
    ],
    expertise: [
      "Joint pain and spinal disorders",
      "Liver and renal diseases",
      "Hair fall and premature greying",
      "Cupping therapy for pain management and detoxification",
      "Patient-friendly, humble approach",
      "Integration of Ayurveda with modern medical understanding",
    ],
    photo_url: "",
    available: true,
    whatsapp_number: "918199937841",
    location: "Chandigarh",
    bio: " Dr. Aman Arora, BAMS, is an Ayurvedic physician with focused expertise in musculoskeletal and spine disorders. He addresses chronic pain, mobility limitations, and structural imbalances through evidence-based traditional care. His clinical interests also extend to neurodegenerative disorders, where he emphasizes long-term functional support, offering holistic, root-cause-oriented treatment for sustainable health outcomes.",
  }
];
